export default {
  methods: {
    fetchData() {},
  },
  watch: {
    '$route.path': function () {
      // Path changed. Resend request
      this.$nextTick(() => {
        this.fetchData();
      });
    },
  },
};
